import React from 'react';
import PropTypes from 'prop-types';
import GenericCMSBoothFilter from './filterTemplates/cms/GenericCMSBoothFilter';
import GenericCMSMobileFilter from './filterTemplates/cms/GenericCMSMobileFilter';

const BoothFilter = ({ ...props }) => (
  <>
    <GenericCMSBoothFilter {...props} />
    <GenericCMSMobileFilter {...props} />
  </>
);

BoothFilter.propTypes = {
  withFilter: PropTypes.bool,
};

BoothFilter.defaultProps = {
  withFilter: false,
};

export default BoothFilter;
